<template>
  <div>
    <div
      v-for="(item, index) in wizard[currentModule].questions"
      :key="`careLevelStep-${index}`"
      :id="`careLevelStep-${index}`"
    >
      <Divider :class="`${el}__divider`" v-if="index <= currentQuestion" />
      <InViewAnimation v-if="index <= currentQuestion">
        <Copy slot="1" element="div">
          {{
            $t('careLevelCalculator.wizard.module.question', {
              from: index + 1,
              to: questionsLength,
            })
          }}
        </Copy>
        <Copy
          :staticClass="`${el}__questionHeadline`"
          slot="2"
          element="div"
          size="l"
          color="primaryBlue"
          bold
        >
          {{ item.question }}

          <Icon
            v-if="item.info"
            :class="`${el}__questionInfo`"
            name="information-line"
            color="primaryBlue"
            :content="item.info"
            v-tippy="{ arrow: true }"
            isButton
          />
        </Copy>

        <div
          v-for="(answerItem, answerIndex) in item.answers"
          :key="`baseRadio-${currentModule}-${answerIndex}`"
          :slot="3 + answerIndex"
        >
          <template v-if="answerIndex !== 1 || !item.hideDayOption">
            <template
              v-if="
                item.withInputCounter &&
                activeWizardAnswers[currentModule][index] === answerIndex &&
                activeWizardAnswers[currentModule][index] > 0
              "
            >
              <InputCounter
                class="u-margin__top--1"
                :defaultValue="activeCounterInputValues[index] || 1"
                @change="(value) => $emit('onInputCounterChange', index, value)"
              />
            </template>
            <BaseRadio
              :id="`question-${currentModule}-${index}-${answerIndex}`"
              :name="`question-${currentModule}-${index}`"
              :label="answerItem"
              checkmark
              advanced
              hasMargin
              :checked="activeWizardAnswers[currentModule][index] === answerIndex"
              @input="$emit('change', index, answerIndex)"
              tabindex="0"
              @keyup.enter.native="$emit('change', index, answerIndex)"
              @keyup.space.native="$emit('change', index, answerIndex)"
              role="radio"
              :aria-checked="activeWizardAnswers[currentModule][index] === answerIndex"
            />
          </template>
        </div>

        <div
          v-if="currentQuestion === index"
          :slot="3 + item.answers.length + 1"
          :class="`${el}__button`"
        >
          <Divider class="u-margin__bottom--3" dotted />

          <Button
            @click="questionsLength - 1 === currentQuestion ? $emit('nextPage') : nextQuestion()"
            :label="
              questionsLength - 1 === currentQuestion
                ? $t(
                    currentModule === wizard.length - 1
                      ? 'careLevelCalculator.resultButton'
                      : 'careLevelCalculator.nextModuleButton'
                  )
                : $t('careLevelCalculator.nextDetailButton')
            "
            additionalIconName="arrow-right-line"
            :disabled="activeWizardAnswers[currentModule][index] === null"
            :loading="loading"
            small
            expand
          />
        </div>
      </InViewAnimation>
    </div>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';
import Button from '@/objects/Button';
import Divider from '@/objects/Divider';
import BaseRadio from '@/objects/Forms/BaseRadio';
import InputCounter from '@/objects/InputCounter';
import InViewAnimation from '@/components/InViewAnimation';
import { scrollTo } from '@/helpers/scroll';

import { mapFieldsCareLevelCalculator } from '@/store/mapFields';

export default {
  name: 'CareLevelCalculatorWizardMobile',
  props: {
    wizard: Array,
    el: String,
    currentModule: Number,
    loading: Boolean,
  },
  components: {
    Copy,
    Divider,
    Button,
    Icon,
    BaseRadio,
    InputCounter,
    InViewAnimation,
  },
  data() {
    return {
      currentQuestion: 0,
    };
  },
  computed: {
    ...mapFieldsCareLevelCalculator(['activeWizardAnswers', 'activeCounterInputValues']),

    questionsLength() {
      return this.wizard[this.currentModule].questions.length;
    },
  },
  methods: {
    nextQuestion() {
      this.currentQuestion += 1;
      setTimeout(() => scrollTo(`#careLevelStep-${this.currentQuestion}`, 0), 100);
    },
  },
};
</script>
